import { TemplatePositionApi, errors } from '@/api/production/Template/TemplatePositionApi'
import { createBaseController } from '@/controllers/baseController'
import { createBaseFileController } from '@/controllers/baseFileController'

export default {
  ...createBaseController(TemplatePositionApi, errors),
  ...createBaseFileController(TemplatePositionApi, errors)
}
